module.exports = __webpack_public_path__ + "fonts/Gilroy-BlackItalic.df2b7fe0.eot";